<template>
  <div>
    <h1>Roles</h1>
  </div>
</template>
<script>
import { API } from "@/tic"
export default {
  name: "Roles",
  mounted(me) {
    console.log("mounted roles **", this.$route.name)
  },

  created() {
    let url = `/admin/list/${this.$route.name}`
    API.get(url).then(resp => {
      console.log("st: ", resp.data)
      this.stats = resp.data
    })
  }
}
</script>
